import { Typography, Box, List, Container, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { BaustellenTerminListItem } from "../components/arbeitsplan/BaustellenTerminListItem";
import { PageTitleWithUnderline } from "../components/common/PageTitleWithUnderline";
import { SubPageTitleWithUnderline } from "../components/common/SubPageTitleWithUnderline";
import { DaySelection } from "../components/arbeitsplan/DaySelection";
import { ArbeitsplanType, selectedDayType } from "../utils/types";
import { getIsAnyDateInRange } from "../utils/helperFunctions";
import { PageWrapper } from "../components/common/PageWrapper";
import { KachelBox } from "../components/common/KachelBox";
import { filterFortbildungen } from "../components/arbeitsplan/ArbeitsplanFilter";
import { GeneralArbeitsplanListItem } from "../components/arbeitsplan/GeneralArbeitsplanListItem";

export const FortbildungPage = () => {
  const [weiterbildungArbeitsplan, setWeiterbildungArbeitsplan] = useState<
    ArbeitsplanType[][]
  >([]);
  const [users, setUsers] = useState([]);
  const [selectedDays, setSelectedDays] = useState<selectedDayType[]>([]);

  useEffect(() => {
    const getArbeitsplan = async () => {
      const response = await fetch(`/api/getArbeitsplan/`, {
        cache: "no-cache",
      });
      const data = await response.json();
      let filteredData: ArbeitsplanType[][] = filterFortbildungen(data);
      if (selectedDays && selectedDays.length > 0) {
        filteredData = filteredData.filter((planList: ArbeitsplanType[]) =>
          selectedDays.some((tag) => getIsAnyDateInRange(planList[0], tag.days))
        );
      }

      // fortbildungen
      setWeiterbildungArbeitsplan(filteredData);
    };

    getArbeitsplan();
  }, [selectedDays]);

  useEffect(() => {
    const getAllUsers = async () => {
      const response = await fetch(`/api/getAllUsers/`);
      const data = await response.json();
      setUsers(data);
    };
    getAllUsers();
  }, []);

  return (
    <PageWrapper>
      <SubPageTitleWithUnderline title="Schule/Fortbildung" />
      <DaySelection
        selectedDays={selectedDays}
        setSelectedDays={setSelectedDays}
        windowSize={window.innerWidth}
        preselectToday={true}
      />
      {weiterbildungArbeitsplan != null &&
        weiterbildungArbeitsplan.length > 0 && (
          <KachelBox>
            {weiterbildungArbeitsplan.map((arbeitsplan, index) => (
              <GeneralArbeitsplanListItem
                key={index}
                workPlanList={arbeitsplan}
                userList={users}
              />
            ))}
          </KachelBox>
        )}
    </PageWrapper>
  );
};
